import { TranslationQuery } from 'next-translate';
import nextTranslate from 'next-translate/useTranslation';
import { useContext } from 'react';
import { AgentSessionContext, BrandContext } from 'pages/_app';

export declare type Translate = <T = string>(
  key: string,
  customerTypeSpecificTranslation?: boolean,
  query?: TranslationQuery | null,
  options?: {
    returnObjects?: boolean;
    fallback?: string | string[];
    default?: string;
    ns?: string;
  },
) => T;

export const useTranslation = (namespace: string): { t: Translate } => {
  const brand = useContext(BrandContext);
  const { t } = nextTranslate(namespace);
  const { session } = useContext(AgentSessionContext);

  const localT = (
    key: string,
    customerTypeSpecificTranslation?: boolean,
    query?: TranslationQuery | null,
    options?: {
      returnObjects?: boolean;
      fallback?: string | string[];
      default?: string;
      ns?: string;
    },
  ) => {
    let customKey = key;

    if (customerTypeSpecificTranslation) {
      const lastIndexOfDot = key.lastIndexOf('.');

      customKey =
        key.substring(0, lastIndexOfDot + 1) +
        session?.user?.customerType?.toLowerCase() +
        '-' +
        key.substring(lastIndexOfDot + 1, key.length);
    }

    return t(
      customKey,
      {
        ...brand?.details?.translations,
        ...query,
      },
      { ...options },
    );
  };

  return { t: localT as Translate };
};
